'use strict';

angular.module('app').config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    //$locationProvider.html5Mode(true).hashPrefix('!');
    $locationProvider.html5Mode(false);
    //$urlRouterProvider.otherwise('/home');
}